module.exports = __webpack_public_path__ + "assets/img/float-aperture-back.eed6ddbe.png";